@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.open {
  .dropdown-toggler-chevron-icon-wrapper {
    > svg {
      transform: rotate(-180deg);
    }
  }
}

.dropdown-menu {
  display: inline-block;
}

.inner-dropdown-menu {
  border-radius: 4px;
  margin: 5px 0;
  max-height: 325px;
  overflow: auto;
  max-width: 385px;
  box-shadow: 1px 1px 3px @dropdown-menu--inner-dropdown-menu--box-shadow-color;

  & > FORM {
    position: fixed;
  }

  .form-container {
    border: none;
    border-radius: 0;
  }

  &.full-width {
    max-width: none;
  }

  a {
    color: var(--default--text-color--4);
  }

  a:hover[href] {
    color: var(--default--text-color--4);
    text-decoration: none;
  }
}

.full-width {
  width: 100%;
}

.full-height {
  max-height: 390px;
}
